// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__W11hT","vLegacy":"SelectSecondary_vLegacy__2mBkn","error":"SelectSecondary_error__2n0Be","disabled":"SelectSecondary_disabled__2eIjg"};